//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'empExperience',
    props: {
        collapseList: Array,
        title: String,
        defaultActive: Number
    },
    data() {
        return {
            activeIndexes: [],
            history: [],
        }
    },
    methods: {
        onChangeHome(e) {
            this.activeIndexes = e;
            const last = e.length ? e.slice(-1)[0] : 0;

            for (let i = 0; i < this.collapseList.length; i++) {
                this.collapseList[i].active = e.indexOf(i) >= 0;
            }

            //计算过了则跳过
            if (this.history.indexOf(last) < 0) {
                this.history.push(last);
                if (this.collapseList.length && this.collapseList[last].data && this.collapseList[last].data.length) {
                    this.calcResumeLine(last);
                }
            }
        },
        //仅计算我的履历下的折叠样式
        calcResumeLine(index) {
            const personalExperience = this.$x('.personal-experience')[0];
            const items = this.$x('.van-collapse-item', personalExperience)[index];
            if (items) {
                this.$nextTick(() => {
                    const line = this.$x('.details-sort-line', items);
                    const list = this.$x('.details-sort', items);
                    const lastHeight = list[list.length - 1].clientHeight;
                    line[0].style.height = 'calc(100% - ' + lastHeight + 'px)';
                });
            }
        },
    },
}
